import React from 'react';

import cs from 'classnames';
import {Link} from 'react-router';

import {DocumentActionsButton} from 'app/components/general/DocumentActionsButton';
import {
  StyledCompactItemHeaderDiv,
  StyledCompactItemHeaderSpan,
} from 'app/general/bootstrap/utils';
import {DocIsDraftBadge} from 'app/general/dashboards/DocIsDraftBadge';
import {ItemLatestActivity} from 'app/general/dashboards/ItemLastActivity';
import {
  type BadgeRelation,
  ItemRelationsBadges,
} from 'app/general/dashboards/ItemRelationsBadges';
import {ItemRelationsLists} from 'app/general/dashboards/ItemRelationsLists';
import {DocumentIconWithNotifications} from 'app/notifly/components/DocumentIconWithNotifications';
import {DashboardItemPresentMembers} from 'app/presence/components/DashboardItemPresentMembers';
import {StyledDocItem} from 'app/procedures/styles';
import {getObjectName} from 'app/utils/fallbacks';

import {ContentType, QuizSerializedType} from 'sweet-types';

import type {NotificationType} from 'app/notifly/types';

interface Props {
  object: QuizSerializedType;
  sortBy?: string;
  activeRelations?: Record<ContentType, boolean> | Record<string, boolean>;
  toggleRelation: (arg0: ContentType, arg1: boolean) => any;
  notifications?: Array<NotificationType>;
  refreshData: () => void;
}

export const CompactQuizListItem = ({
  object,
  sortBy,
  activeRelations,
  toggleRelation,
  notifications,
  refreshData,
}: Props) => (
  <StyledDocItem
    className={cs(
      'row border-bottom py-2 d-flex align-items-center position-relative',
      {'opacity-overlay': object.approved_at == null}
    )}
  >
    <DashboardItemPresentMembers contentType="quiz" objectId={object.id} />
    <StyledCompactItemHeaderDiv>
      <Link
        to={object.html_url}
        className="text-dark font-weight-bold d-block d-sm-inline"
      >
        <StyledCompactItemHeaderSpan>
          <DocumentIconWithNotifications
            contentType="quiz"
            notifications={notifications}
          />{' '}
          {getObjectName(object, 'quiz', true)}
        </StyledCompactItemHeaderSpan>
      </Link>
      <DocIsDraftBadge approved_at={object.approved_at} />
    </StyledCompactItemHeaderDiv>
    <ItemRelationsBadges
      className="col-auto ml-auto ml-sm-0 order-lg-3"
      relations={relations}
      object={object}
      activeRelations={activeRelations}
      onToggle={toggleRelation}
    />

    <div className="col col-sm-6 col-lg-3 mr-auto order-lg-4">
      <ItemLatestActivity sortBy={sortBy} object={object} />
    </div>

    <div className="col-auto order-lg-5">
      <DocumentActionsButton
        document={object}
        pageContext="dashboard"
        refreshData={refreshData}
      />
    </div>

    <div className="col-12 order-last">
      <ItemRelationsLists
        object={object}
        activeRelations={activeRelations}
        relations={relations}
      />
    </div>
  </StyledDocItem>
);

const relations: Array<BadgeRelation> = [
  {
    ct: 'team',
    getter: (q: QuizSerializedType) =>
      q.team_memberships.map((team) => team.team),
    Component: ItemRelationsLists,
  },
];
